import React from 'react';

import {
    Redirect,
    withRouter,
    Link,
} from 'react-router-dom'

import { connect } from 'react-redux';
import { compose } from 'redux';

import { onSignIn, isSignedIn } from '../../Auth';

import {
    Grid,
    Modal,
    Button,
    Header,
    Input,
    Segment,
    Form,
    Divider,
    Checkbox,
    Image,
    Item,
    Label,
    Container,Icon
} from 'semantic-ui-react'

import {
    addToken,
    addId 
} from '../../actions/AppAction'

import KnaufLogoCloud from '../../assets/img/Knauf_Insulation_Logo.png'
import './LoginComponent.css'



function mapStateToProps(state) {
    return {
        app: state.app,
    };
}

const mapActionToProps = {
    addToken: addToken,
    addId: addId
}

class LoginComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            redirectToReferrer: false,
            email: null,
            password: null,
            error: null
        }

        this.handleChangeEmail = this.handleChangeEmail.bind(this)
        this.handleChangePassword = this.handleChangePassword.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    handleChangeEmail(e, data) {
        e.preventDefault();

        this.setState({
            email: data.value,
        })
    }

    handleChangePassword(e, data) {
        e.preventDefault();

        this.setState({
            password: data.value,
        })
    }

    setToken(token) {
        this.props.addToken(token)
    }

    setId(id) {
        this.props.addId(id)
    }

    setLang(lang) {
        this.props.addLanguage(lang)
    }

    handleSubmit(e) {
        e.preventDefault();

        onSignIn(this.state.email, this.state.password)
            .then(res => {
                if (res) {
                    this.setState({ redirectToReferrer: true });

                    let token = localStorage.getItem('USER_TOKEN');

                    var base64Url = token.split('.')[1];
                    var base64 = base64Url.replace('-', '+').replace('_', '/');
                    var tmp = JSON.parse(window.atob(base64));

                    let id = tmp['id'];
                    let lang = tmp['language'];

                    this.setToken(token)
                    this.setId(id)
                    this.setLang(lang)

                }
            })
            .catch(err => {
                this.setState({
                    error: err
                })
            });
    }

    render() {
        const { from } = this.props.location.state || { from: { pathname: "/" } };
        const { redirectToReferrer } = this.state;

        if(isSignedIn()){
            return <Redirect to="/home" />;
        }

        if (redirectToReferrer) {
            if (from === null || from.pathname === "/") {
                return <Redirect to="/home" />;
            }
            return <Redirect to={from} />;
        }

        return (

            // dans le cas du modal ??
            <div>
                <Image src={KnaufLogoCloud} size="large" id="KnaufLogoCloud" />
                    <Grid
                    textAlign='center'
                    style={{ height: '100%' }}
                    verticalAlign='middle'>
                    <Grid.Column style={{ maxWidth: 450 }}>
                        <Link to='/protected'></Link>
                        {/* <a href='/'><Image src={Exit} floated='right' /></a> */}
                        <Header as='h3' style={{ color: '#0964c1', margin: '1em 0 1em 0' }} textAlign='center'>
                            CONNEXION
                            </Header>
                        {/* SOCIAL COMPONENT <Demo /> */}
                        
                        <Form onSubmit={this.handleSubmit}>
                            <Form.Input
                                style={{ backgroundColor: '#f7f7f8' }}
                                onChange={this.handleChangeEmail}
                                name="email"
                                fluid
                                placeholder='E-mail'
                            />

                            <Form.Input
                                onChange={this.handleChangePassword}
                                name="password"
                                type="password"
                                fluid
                                placeholder='Mot de passe'
                            />
                            <Button type='submit' fluid style={{ height: '45px' }} color='yellow'>Connexion</Button>
                        </Form>

                        {
                            this.state.error === null ? (
                                <div></div>
                            ) : (
                                    <Segment>
                                        <Header as="p" >{JSON.stringify(this.state.error)}</Header>
                                    </Segment>
                                )
                        }
                    </Grid.Column>
                </Grid>

                    
                    </div>
        );
    }
}


export default compose(
    withRouter,
    connect(mapStateToProps),
)(LoginComponent);



// WEBPACK FOOTER //
// ./src/components/Login/LoginComponent.js